import React, { useState, useEffect } from "react";
import { Box, Grid, Stack, Alert } from "@mui/material";
import TargetColorSection from "./targetColorSection";
import AchievableColorResult from "./achievableColorResult";
import RecycledGamut from "./recycledResinGamut";
import RecycledAndVirginGamut from "./recycledAndVirginGamut";
import VirginGamut from "./virginResinGamut";
import Loader from "./loader";
//import Loader from '../lib/loader';
import Gamut from "../../modal/Gamut";
import { useStoreState, useStoreActions } from "easy-peasy";
import { gamutChartAPI } from "../../apis/index";
import {
  plotlyGamutGraphTreaceData,
  resinMaterialDetails,
  removeHtmlEntitiesAndTags,
  virginResinMaterialDetails,
} from "./../../utils/graph-helper";
import ErrorMessage from "./errorMessage";
import { GraphProvider } from "./graphContext";
import RecycledResin from "./../../asset/VirRecR.jpeg";
import GreyRecycledResin from "./../../asset/VirginR.jpeg";
import ColorRecycled from "./../../asset/RecycledR.jpeg";
import { resinAPI } from "../../apis/index";

const textCss = {
  fontSize: "14px",
  fontFamily: "Source Sans Pro",
  fontWeight: "400",
  lineHeight: "opx",
  wordWrap: "break-word",
  paddingTop: "0px",
};

const highlightCss = {
  width: "85%",
  fontSize: "10px",
  padding: "8px",
  background: "rgba(55, 147, 213, 0.12)",
  borderRadius: "5px",
  border: "1px #385DAE solid",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "8px",
  display: "inline-flex",
  color: "#385DAE",
  cursor: "pointer",
};

const notHighlightCss = {
  width: "85%",
  fontSize: "10px",
  padding: "8px",
  padding: "8px",
  background: "white",
  borderRadius: "5px",
  border: "1px #C7C9C7 solid",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "8px",
  display: "inline-flex",
  color: "#303C43",
  cursor: "pointer",
};

export const EvaluationResults = () => {
  const [selectedInput, setSelectedInput] = useState("recycledVirgin");
  const [loading, setLoading] = useState(true);
  const [evaluationReportData, setEvaluationReportData] = useState(null);
  const [achievableColorData, setAchievableColorData] = useState([]);
  const [targetColorData, setTargetColorData] = useState([]);
  let requirements = useStoreState((state) => state.requirements);
  const setDownloadBtnDisabled = useStoreActions(
    (actions) => actions.setDownloadBtnDisabled
  );
  let setEvaluationResult = useStoreActions(
    (actions) => actions.setEvaluationResult
  );
  let setDownloadReport = useStoreActions(
    (actions) => actions.setDownloadReport
  );

  let currentUser = useStoreState((state) => state.currentUser);

  let inputColor = useStoreState((state) => state.inputColor);
  const [error, setError] = useState(null);

  const handleClick = (type) => {
    setSelectedInput(type);
  };

  const fetchData = async () => {
    const gamutObj = new Gamut(requirements, inputColor, currentUser);
    try {
      const payload = gamutObj.getPayload();
      /* Get the gamut data service response*/
      let result = {
        target_color: [],
      };
      result = await gamutChartAPI
        .checkGamutGraphService(payload)
        .then((result) => {
          setEvaluationResult(result);
          let graphData = plotlyGamutGraphTreaceData(
            result,
            result["target_color"]
          );
          setEvaluationReportData({ data: graphData });
          const targetColorData = result.target_color;
          const data = targetColorProcessing(targetColorData);
          setAchievableColorData(data.achievableColorData);
          setTargetColorData(data.targetColorData);
          return result;
        });
      setDownloadBtnDisabled(false);
    } catch (error) {
      console.log(error);
      setDownloadBtnDisabled(true);
      setEvaluationResult([]);
      setLoading(false);
      setError(error);
      setEvaluationReportData({ data: [] });
      setAchievableColorData([]);
      setTargetColorData([]);
    } finally {
      setLoading(false);
      /* call the evaluation result API */
      const evaluationReportPayload = gamutObj.getEvaluationReoprtPayload();
      resinAPI.postEvaluationRequest(evaluationReportPayload);
    }
  };

  const targetColorProcessing = (targetColorData) => {
    const totalCount = targetColorData.length;
    let achievableColorCount = 0;
    const colorCategory = ["All"];

    let achievableColorData = {
      achieveColorCount: 0,
      totalColorCount: totalCount,
      otherDetails: resinMaterialDetails(requirements),
      virginResinDetails: virginResinMaterialDetails(requirements),
    };

    const targetColor = [];
    targetColorData.forEach((element, index) => {
      /* Prepare acheivable left side data */
      element.doable ? achievableColorCount++ : null;
      let category = element.color_cat.toLowerCase();
      category =
        [...category][0].toUpperCase() + [...category].slice(1).join("");

      /* Get inpit color state value of uploadedColorArray and split LAB name value over here */
      colorCategory.includes(category) ? null : colorCategory.push(category);
      let colorName = "NA";
      if (inputColor["uploadedColorArray"][index]?.name) {
        colorName = removeHtmlEntitiesAndTags(
          inputColor["uploadedColorArray"][index]?.name
        );
      }
      const color = {
        target_color_rgb: element.RGB,
        target_color_name: colorName, //'PE00077124',
        color_category: category,
        nearest:
          element.RGB_of_9_colors.length > 0
            ? element.RGB_of_9_colors[0]
            : null,
        "dE*": element?.delta_values?.dE_star
          ? element?.delta_values?.dE_star.toFixed(2)
          : "",
        result: element?.doable ? true : false,
      };
      targetColor.push(color);
    });
    achievableColorData.achieveColorCount = achievableColorCount;
    /* final response format */
    return {
      achievableColorData: achievableColorData,
      targetColorData: {
        colorCategoryOptions: colorCategory,
        resultOptions: ["All", "OK", "NOK"],
        achievableColorTablerows: targetColor,
      },
    };
  };

  useEffect(() => {
    setDownloadReport({
      pointsVisible: ["All"],
    });
    if (loading) {
      window.scrollTo(0, 0); // Scroll to the top when loader is shown
    }
    fetchData();
  }, []);

  return (
    <div className="page-container">
      {loading ? (
        <Loader
          message="Evaluating color achievability with recycled resin..."
          className="overlay"
        />
      ) : (
        <>
          {error ? (
            <Box>
              <ErrorMessage errors={error?.response?.data?.detail} />
            </Box>
          ) : (
            /*
            Evaluation page error message handling
          */
            <GraphProvider>
              <Box sx={{ mb: "30px" }}>
                <Grid container spacing={1}>
                  <Grid xs={5.9} item>
                    <Stack
                      direction="column"
                      spacing={1}
                      sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <AchievableColorResult
                          achievableColorData={achievableColorData}
                        />
                      </Box>
                      <Box sx={{ width: "100%" }}>
                        <TargetColorSection targetColorData={targetColorData} />
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid xs={0.1}></Grid>
                  <Grid xs={6} item spacing={2}>
                    <Box>
                      <h3>Gamut Analysis</h3>
                    </Box>
                    <Grid
                      container
                      xs={12}
                      sx={{ marginLeft: "12px !important" }}
                    >
                      <Grid xs={1}>
                        <Box>
                          <h5>View</h5>
                        </Box>
                      </Grid>

                      <Grid xs={10}>
                        <Grid container xs={12}>
                          <Grid xs={4} style={{ width: "85% !important" }}>
                            <Box
                              sx={
                                selectedInput == "recycledVirgin"
                                  ? highlightCss
                                  : notHighlightCss
                              }
                              onClick={() => handleClick("recycledVirgin")}
                            >
                              <img
                                src={RecycledResin}
                                title="Recycled Resin"
                                alt="Recycled Resin"
                                style={{ height: "38px" }}
                              />
                              <Box sx={textCss}>
                                Recycled <br />& Virgin Resin
                              </Box>
                            </Box>
                          </Grid>
                          <Grid xs={4.1}>
                            <Box
                              sx={
                                selectedInput == "recycled"
                                  ? highlightCss
                                  : notHighlightCss
                              }
                              onClick={() => handleClick("recycled")}
                            >
                              <img
                                src={ColorRecycled}
                                title="Grey-Recycled & Virgin Resin"
                                alt="Grey-Recycled & Virgin Resin"
                                style={{ height: "38px" }}
                              />
                              <Box sx={textCss} style={{ paddingTop: "8px" }}>
                                Recycled Resin
                              </Box>
                            </Box>
                          </Grid>
                          <Grid xs={3.8}>
                            <Box
                              sx={
                                selectedInput == "colorRecycled"
                                  ? highlightCss
                                  : notHighlightCss
                              }
                              onClick={() => handleClick("colorRecycled")}
                            >
                              <img
                                src={GreyRecycledResin}
                                title="Color-Recycled & Virgin Resine"
                                alt="Color-Recycled & Virgin Resine"
                                style={{ height: "38px" }}
                              />
                              <Box sx={textCss} style={{ paddingTop: "8px" }}>
                                Virgin Resin
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* Recycled resing component */}
                    <Box style={{ marginTop: "10px" }}>
                      {/* {selectedInput == 'recycled' ? (
                    <RecycledGamut gamutData={ evaluationReportData.data}/>
                  ) : selectedInput == 'recycledVirgin' ? (
                    <RecycledAndVirginGamut gamutData={ evaluationReportData.data} />
                  ) : (
                    <VirginGamut gamutData={ evaluationReportData.data}/>
                  )} */}

                      {selectedInput === "recycled" && (
                        <div>
                          <RecycledGamut
                            gamutData={evaluationReportData.data}
                          />
                        </div>
                      )}
                      {selectedInput === "recycledVirgin" && (
                        <div>
                          <RecycledAndVirginGamut
                            gamutData={evaluationReportData.data}
                          />
                        </div>
                      )}
                      {selectedInput === "colorRecycled" && (
                        <div>
                          <VirginGamut gamutData={evaluationReportData.data} />
                        </div>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </GraphProvider>
          )}
        </>
      )}
    </div>
  );
};
